import {Dispatch} from "redux";
import {IFlyerRuntimePageSpot} from "../../dtos/flyer";
import {TAddToBasketActions} from "../actions/selectedSpotActions";

export const addSelectedSpot = (data: IFlyerRuntimePageSpot, index: number, event: object, pageImage: string, isLoading: boolean) => {
    return async (dispatch: Dispatch<TAddToBasketActions>) => {
        dispatch({
            type: "SET_ADD_TO_BASKET_ITEM",
            payload: {
                spot: data,
                index,
                event,
                pageImage,
                isLoading
            },
        });
    };
};

export const updateDataForPromoFromBasket = (frame: IFlyerRuntimePageSpot) => {
    return async (dispatch: Dispatch<TAddToBasketActions>) => {
        dispatch({
            type: "UPDATE_PROMO_POPUP",
            payload: {
                spot: frame,
                isLoading: true
            },
        });
    };
};

export const changeLoadingStatusForSelectedFrame = (isLoading: boolean) => {
    return async (dispatch: Dispatch<TAddToBasketActions>) => {
        dispatch({
            type: "SET_LOADING_STATUS_FOR_FRAME",
            payload: {
                isLoading
            },
        });
    };
};

export const togglePromotionPopup = (statusForPopup: string) => {
    localStorage.setItem(`isExpandedPromoPopup`, statusForPopup);
    return async (dispatch: Dispatch<TAddToBasketActions>) => {
        dispatch({
            type: "TOGGLE_PROMOTION_POPUP",
            payload: {
                isExpanded: statusForPopup === 'expanded'
            },
        });
    };
};

export const removeSelectedSpot = () => {
    return async (dispatch: Dispatch<TAddToBasketActions>) => {
        dispatch({
            type: "REMOVE_ADD_TO_BASKET_ITEM",
        });
    };
};
